export default {
    'name': 'member-en',
    'width': '32',
    'height': '32',
    'viewBox': '0 0 32 32',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM8.89844 23V8.89999H11.0384L16.0384 18.12L21.0184 8.89999H23.1184V23H20.7984V13.5L16.7584 20.86H15.2584L11.2184 13.54V23H8.89844Z\' fill=\'#19405B\'/>'
}
